import request from '@/utils/request'

export function getVersionApi(params) {
  return request({
    url: '/api/Index/GetPlatformversion',
    method: 'get',
    params
  })
}

export function getNavListData(params) {
  return request({
    url: '/api/Index/IndexBar', // /api/Main/IndexBar /api/Index/IndexBar
    method: 'get',
    params
  })
}

export const setNavOrder = params => {
  return request({
    url: '/api/Index/UpdIndexBar', // /api/Main/UpdIndexBar /api/Index/UpdIndexBar
    method: 'get',
    params
  })
}

export const getSwiperList = () => {
  return request({
    url: '/api/Index/IndexBanner',
    method: 'get'
  })
}

export const recordingPageOpen = params => {
  return request({
    url: '/api/Index/QueryOpenTime',
    method: 'get',
    params
  })
}
export const recordingPageOff = params => {
  return request({
    url: '/api/Index/QueryCloseTime',
    method: 'get',
    params
  })
}

// get living url
export const getLivingUrl = () => {
  return request({
    url: 'Api/Index/Query',
    method: 'get'
  })
}

// onlyoffice 获取 jwt-token
export const getJwtTokenApi = () => {
  return request({
    url: '/api/Index/QueryJwtToken',
    method: 'post'
  })
}
